// WHERE YOU HAVE BEEN, so a chain can be walked backwards.
//
// The browser's own back button goes one step and tells you nothing about the
// route. Tracing correspondences is the whole point of this section — metals
// to planets to days to sephiroth — and a reader four tables in wants to see
// the way they came and step back to any part of it, not just the last one.
//
// Kept in sessionStorage: per tab, gone when the tab is, never sent anywhere.
// This is a record of one person's browsing and it has no business on a server.
const KEY = "correspondence-trail";
const LIMIT = 12;

// Revisiting somewhere TRUNCATES to it rather than appending. Without that,
// pressing the browser's back button would grow the trail instead of shortening
// it, and a reader going back and forth twice would leave a trail of four.
export function pushStep(trail, step) {
  const at = trail.findIndex((one) => one.url === step.url);
  if (at >= 0) return trail.slice(0, at + 1);
  return [...trail, step].slice(-LIMIT);
}

export function readTrail(storage = sessionStorage) {
  try {
    const raw = storage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    // A private window, cleared storage, or a browser refusing it outright.
    // The trail is a convenience; losing it costs a reader nothing they
    // cannot get from the page they are on.
    return [];
  }
}

export function writeTrail(trail, storage = sessionStorage) {
  try {
    storage.setItem(KEY, JSON.stringify(trail));
  } catch {
    /* see readTrail */
  }
}

function render(holder, trail) {
  holder.textContent = "";
  // One step is where you are; there is nothing to go back to.
  if (trail.length < 2) return;

  const nav = document.createElement("nav");
  nav.className = "trail";
  nav.setAttribute("aria-label", "The tables you came through");

  const previous = trail[trail.length - 2];
  const back = document.createElement("a");
  back.className = "trail__back";
  back.href = previous.url;
  back.dataset.testid = "trail-back";
  back.textContent = `← Back to ${previous.label}`;
  nav.appendChild(back);

  const list = document.createElement("ol");
  list.className = "trail__list";
  trail.forEach((step, index) => {
    const item = document.createElement("li");
    if (index === trail.length - 1) {
      // Where you are now. A link to here would go nowhere.
      const here = document.createElement("span");
      here.className = "trail__here";
      here.setAttribute("aria-current", "page");
      here.textContent = step.label;
      item.appendChild(here);
    } else {
      const link = document.createElement("a");
      link.href = step.url;
      link.textContent = step.label;
      item.appendChild(link);
    }
    list.appendChild(item);
  });
  nav.appendChild(list);

  const clear = document.createElement("button");
  clear.type = "button";
  clear.className = "trail__clear";
  clear.dataset.testid = "trail-clear";
  clear.textContent = "Start again";
  clear.addEventListener("click", () => {
    writeTrail([]);
    render(holder, []);
  });
  nav.appendChild(clear);

  holder.appendChild(nav);
}

export function start() {
  if (typeof document === "undefined") return;
  const holder = document.querySelector("[data-correspondence-trail]");
  if (!holder) return;

  const label = holder.dataset.trailLabel;
  if (!label) return;

  const trail = pushStep(readTrail(), {
    url: window.location.pathname + window.location.search,
    label
  });
  writeTrail(trail);
  render(holder, trail);
}
